/* --------------------------------------------------------------------------------------
   redirect.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const xeroxssoComponent = {
  template: "",
  controllerAs: "vm",
  controller: class xeroxssoComponentCtrl {
    /* @ngInject */
    constructor(
      commonService,
      apiClientService,
      ssoClientService,
      xeroxSsoService,
      persistService,
      $state
    ) {
      this.commonService = commonService;
      this.apiClientService = apiClientService;
      this.ssoClientService = ssoClientService;
      this.xeroxSsoService = xeroxSsoService;
      this.persistService = persistService;
      this.$state = $state;
    }
    async $onInit() {
      const routeParams = this.getRouteParams();
      this.route = routeParams.route;
      this.commonService.updateView();
      if (routeParams.route == "authentication") this.$state.go("redirect");

      if (routeParams.route == "error") {
        const clioToken = this.persistService.getObject("clioTokenData", true);
        const accountCountry = this.persistService.getObject("accountCountry");
        const authStatus = await this.ssoClientService.getAuthStatus(clioToken);
        if (authStatus) {
          this.ssoClientService.setTokenLocally(authStatus);
          this.apiClientService.setTokenAuthHeader(
            authStatus.access_token,
            accountCountry
          );
          this.$state.go("main");
        } else {
          this.$state.go("redirect");
        }
      }

      if (routeParams.route == "main") {
        this.ssoClientService.setTokenLocally(null);
        this.clioToken = this.getClioToken(routeParams.token);
        const authStatus = await this.ssoClientService.getAuthStatus(
          this.clioToken
        );
        const accountCountry = this.persistService.getObject("accountCountry");
        if (authStatus) {
          this.apiClientService.setTokenAuthHeader(
            authStatus.access_token,
            accountCountry
          );
          this.$state.go("main");
        } else {
          this.xeroxSsoRefreshModel =
            await this.xeroxSsoService.getRefreshModel(
              routeParams,
              this.clioToken
            );
          this.commonService.updateView();
        }
      }
    }
    getRouteParams() {
      const params = new URLSearchParams(window.location.search);
      const decodedToken = atob(params.get("token"));
      return {
        route: params.get("route"),
        token: angular.fromJson(decodedToken),
        sessionId: params.get("sessionId"),
        updatedAccessToken: params.get("updatedAccessToken"),
        updatePath: params.get("updatePath"),
      };
    }
    getClioToken(token) {
      return angular.fromJson(token.largeData);
    }
    getClioMessage(token) {
      return token.message;
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/xeroxsso.component.js